import { cn } from "cn";
import type { FC } from "react";
import React from "react";

import { Skeleton } from "@react/ui-primitives/skeleton";

interface GenerationCardSkeletonProps {
  readonly className?: string;
}

export const GenerationCardSkeleton: FC<GenerationCardSkeletonProps> = ({
  className,
}) => (
  <div className={cn("flex flex-col gap-2 rounded-md border p-3", className)}>
    <div className="flex items-center justify-between">
      <Skeleton className="w-24" variant="text-label" />
      <Skeleton className="w-20" variant="text-label" />
    </div>
    <Skeleton variant="text-line" />
    <div
      className={`
        grid grid-cols-2 gap-3
        sm:grid-cols-3
        lg:grid-cols-4
      `}
    >
      <Skeleton className="aspect-square" />
    </div>
  </div>
);
